export const storiaClinicaModified = (storiaClinica) => {
    if (storiaClinica) {
        return Object.values(storiaClinica).some(
            (val) => val !== undefined && val !== null && val.toString().trim() !== ""
        );
    }
    return false;
};

export const storiaFamiliareModified = (storiaFamiliare) => {
    if (storiaFamiliare) {
        var test = (
            ((storiaFamiliare.effectiveTime || "").trim() !== "") ||
            ((storiaFamiliare.diagnosisValue || "").trim() !== "") ||
            ((storiaFamiliare.diagnosisDisplayName || "").trim() !== "")
        );
        return test;
    }
    return false;
};

export const informazioniAggiuntiveModified = (informazioniAggiuntive) => {
    return (informazioniAggiuntive || "").trim() !== "";
};

export const complicanzeModified = (complicanze) => {
    if (complicanze) {
        return (
            ((complicanze.complicazioni || "").trim() !== "") ||
            (
                complicanze.dettaglio &&
                Array.isArray(complicanze.dettaglio) &&
                complicanze.dettaglio.some(
                    (item) =>
                        ((item.effectiveTimeLow || "").trim() !== "") ||
                        ((item.effectiveTimeHigh || "").trim() !== "") ||
                        ((item.nota || "").trim() !== "")
                )
            )
        );
    }
    return false;
};

export const checkSezioniObbligatorie = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    // Seleziona il contenuto della sezione "Esame Eseguito"
    const esameContent = doc.querySelector('[data-section="ESAME_ESEGUITO"] .section-content');
    // Seleziona il contenuto della sezione "Referto"
    const refertoContent = doc.querySelector('[data-section="REFERTO"] .section-content');

    // Verifica che entrambi gli elementi esistano e contengano del testo (al netto degli spazi)
    const isEsameFilled = esameContent && ((esameContent.textContent || "").trim().length > 0);
    const isRefertoFilled = refertoContent && ((refertoContent.textContent || "").trim().length > 0);

    return isEsameFilled && isRefertoFilled;
};
